import React from 'react';
import Header from '../../components/provider/header'; // Adjust the path as necessary
import Dashboard from '../../components/provider/dashboard'; // Adjust the path as necessary
import '../../styles/jobManage.css'; // Import the CSS file
import TaskList from '../../components/provider/task';
import AnalyticCard from '../../components/provider/AnalyticCard';

function JobManage() {
  return (
    <div className="job-manage-container">
      <Dashboard className="job-dashboard" /> {/* Add the Dashboard component */}
      <div className="job-manage-content">
      <Header className="job-header" /> {/* Apply the CSS class */}

        <div className="job-main-content">
          <TaskList className="job-task-list"/>
          <div className="job-analytic-card-container">
            <AnalyticCard/>
          <AnalyticCard className="job-analytic-card"/>
          </div>
          {/* Existing JSX code for JobManage */}
        </div>
      </div>
    </div>
  );
}

export default JobManage;